// A dónde mandar a un usuario que quiere mejorar/cambiar su plan.
//
// Hay UNA sola pregunta que decide eso, y esta es la única definición de la
// respuesta. Antes vivía copiada en tres pantallas (Paywall, CreditsPricingSheet,
// la puerta de Checkout) y MAL en otras diez, que ramificaban por país.
//
// Por qué importa tanto (ADR-661): un cliente de Stripe con suscripción activa
// NO puede pasar por nuestro checkout. Una Checkout Session nueva crea una
// SEGUNDA suscripción y la vieja SIGUE cobrando — nada la cancela, el webhook
// solo pisa `stripe_subscription_id` en la base. El cambio de plan de Stripe se
// hace en su Billing Portal, que hace el swap sobre la suscripción existente con
// prorrateo.
//
// Por qué NO se usa el país: es un proxy del medio de pago, no el medio de pago.
// Verificado contra prod el 2026-08-03: hay 2 empresas con `pais` argentino que
// cobran por Stripe (una escrita "Argentin", con el typo), y las 49 empresas con
// ids de Stripe tienen las 49 `plataforma_pago = 'stripe'` — ninguna empresa de
// otra plataforma tiene ids de Stripe. El discriminador exacto es la plataforma.

import { isPaidPlan } from './planCapabilities';

/**
 * ¿La gestión del plan de esta empresa vive en el Billing Portal de Stripe?
 *
 * `true`  → mandar al portal (`fetchStripeBillingPortalUrl`). Es un cliente de
 *           Stripe con suscripción activa: nuestro checkout le duplicaría el cobro.
 * `false` → mandar al catálogo de planes (`/subscription`). Cubre a Rebill/MP y,
 *           sobre todo, a quien está en `gratis`: sin suscripción no hay portal
 *           que abrir (el server responde `no_stripe_customer`) y lo que necesita
 *           es justamente ver los planes.
 *
 * Ante datos incompletos devuelve `false` — el catálogo es el destino seguro:
 * la puerta de `Checkout.tsx` vuelve a chequear esto antes de cobrar nada.
 */
export function gestionaPlanEnPortalStripe(
  plataformaPago: string | null | undefined,
  plan: string | null | undefined,
): boolean {
  return (plataformaPago ?? '').trim().toLowerCase() === 'stripe' && isPaidPlan(plan);
}
